export default "__VITE_ASSET__5170f7bd__"